import './App.css'
import { AppTheme } from './theme'
import Layout from './layout'
import { lazy, Suspense } from 'react'

const LandingPage = lazy(() => import('./pages/landing'))

function App() {
  return (
    <AppTheme>
      <Layout>
        <Suspense fallback={<div />}> 
          <LandingPage />
        </Suspense>
      </Layout>
    </AppTheme>
  )
}

export default App
